import { ORDER_FULFILLMENT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  pickup: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Deine Bestellung wurde storniert.',
      description: 'Entschuldigung, wir können deine Bestellung derzeit nicht bearbeiten.',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Wir haben deine Bestellung erhalten',
      description: 'Warte auf Bestellbestätigung...',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Wir bereiten deine Bestellung vor',
      description: 'Deine Bestellung ist bestätigt',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Deine Bestellung wurde gesehen',
      description: 'Warte auf Bestellbestätigung...',
    },
    [ORDER_FULFILLMENT_STATUSES.PREPARING]: {
      title: 'Deine Bestellung wird vorbereitet',
      description: 'Wir bereiten deine Bestellung vor',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Deine Bestellung ist fertig und wartet auf dich!',
      description: 'Deine Bestellung ist zur Abholung bereit.',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Deine Bestellung ist fertig!',
      description: 'Deine Bestellung ist fertig.',
    },
  },
  delivery: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Deine Bestellung wurde storniert.',
      description: 'Entschuldigung, wir können deine Bestellung derzeit nicht bearbeiten.',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Wir haben deine Bestellung erhalten',
      description: 'Warte auf Bestellbestätigung...',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Deine Bestellung wurde gesehen',
      description: 'Warte auf Bestellbestätigung...',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Wir bereiten deine Bestellung vor',
      description: 'Deine Bestellung ist bestätigt',
    },
    [ORDER_FULFILLMENT_STATUSES.PREPARING]: {
      title: 'Deine Bestellung wird vorbereitet',
      description: 'Wir benachrichtigen dich, sobald sie unterwegs ist',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Deine Bestellung ist unterwegs!',
      description: 'Deine Bestellung wird bald ankommen.',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Deine Bestellung ist unterwegs!',
      description: 'Deine Bestellung wird bald ankommen.',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Deine Bestellung ist fertig!',
      description: 'Deine Bestellung ist fertig.',
    },
  },
  estimate: 'Schätzung: {{time}}',
};
